import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { columnsBase } from '../constants/columnsCoordinador';
import moment from 'moment';
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";

export const useGetColumnsCoordinador = ({ datosCabecera }) => {
    const { isMobile } = useGetBreakpoints();
    const navigate = useNavigate();

    const handleClickVisita = (row, readOnlyParam) => {
        const auxDataState = {
            ...row,
            isNew: false,
            idTipoProfesional: datosCabecera?.idTipoProfesional,
            idFiguraProfesional: datosCabecera?.idFiguraProfesional,
            onlyView: readOnlyParam,
            visitasProgramadas: `${datosCabecera?.visitasRealizadas} / ${datosCabecera?.visitasEstimadas}`,
            periodo: datosCabecera?.fechaAsignacion
        };

        const route = "/misVisitas/nuevaVisita";

        if (!!route && !!readOnlyParam)
            navigate(route, { state: { ...auxDataState } });
        else
            navigate(route, { state: { ...auxDataState, isClone: true } });
    };

    const actionColumn = {
        headerName: '',
        field: 'action',
        flex: 0.0005,
        width: 40,
        renderCell: (cellProps) => {
            const { row } = cellProps;
            const fechaAltaVisita = moment(row.fechaAlta);
            const dentroDelPlazoDeModificacion = moment().diff(fechaAltaVisita, 'hours') < 48;

            return <>
                <PopoverModal>
                    <div className='popover-modal-content'>
                        <div aria-hidden='true' onClick={() => handleClickVisita(row, true)} className='item-option clickable-option'>
                            <VisibilityIcon className='edit-icon' />
                            <span className='toggle-action'>Ver Visita</span>
                        </div>
                        {dentroDelPlazoDeModificacion && <div aria-hidden='true' onClick={() => handleClickVisita(row, false)} className='item-option clickable-option'>
                            <EditIcon className='edit-icon' />
                            <span className='toggle-action'>Modificar</span>
                        </div>}
                    </div>
                </PopoverModal>
            </>;
        }
    };

    const columns = useMemo(() => {
        const initialColumns = [actionColumn, ...columnsBase];

        const parsedColumns = initialColumns.map((col) => {
            if (!isMobile) return { ...col };
            const { flex, ...rest } = col;
            return { ...rest };
        });

        return generateColumnsDefaultConfiguration(parsedColumns, isMobile);
    }, [isMobile]);

    return columns;
};